/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateClassRoomResponse } from './CreateClassRoomResponse';
import {
    CreateClassRoomResponseFromJSON,
    CreateClassRoomResponseFromJSONTyped,
    CreateClassRoomResponseToJSON,
    CreateClassRoomResponseToJSONTyped,
} from './CreateClassRoomResponse';

/**
 * 
 * @export
 * @interface ResultOfCreateClassRoomResponse
 */
export interface ResultOfCreateClassRoomResponse {
    /**
     * 
     * @type {CreateClassRoomResponse}
     * @memberof ResultOfCreateClassRoomResponse
     */
    data: CreateClassRoomResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfCreateClassRoomResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfCreateClassRoomResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfCreateClassRoomResponse interface.
 */
export function instanceOfResultOfCreateClassRoomResponse(value: object): value is ResultOfCreateClassRoomResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfCreateClassRoomResponseFromJSON(json: any): ResultOfCreateClassRoomResponse {
    return ResultOfCreateClassRoomResponseFromJSONTyped(json, false);
}

export function ResultOfCreateClassRoomResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCreateClassRoomResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreateClassRoomResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfCreateClassRoomResponseToJSON(json: any): ResultOfCreateClassRoomResponse {
    return ResultOfCreateClassRoomResponseToJSONTyped(json, false);
}

export function ResultOfCreateClassRoomResponseToJSONTyped(value?: ResultOfCreateClassRoomResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateClassRoomResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

